<!-- TEXT -->
<!-- <p class="text-note fst-italic">(Se añadirán a los datos del fichero o los modificarán si existen)</p> -->
<div class="">
  <div class="d-flex align-items-end">
    <div class="me-2">
      <label class="subtitle">Section ID</label>
      <input type="text" class="form-control" name="" id="" [(ngModel)]="newTranslationText.section_id" (keyup.enter)="addNewTranslationText()">
    </div>
    <div class="me-2">
      <label class="subtitle">New name</label>
      <input type="text" class="form-control" name="" id="" [(ngModel)]="newTranslationText.translation" (keyup.enter)="addNewTranslationText()">
    </div>
    <div class="mb-1">
      <button class="btn-secondary-action" title="Añadir" (click)="addNewTranslationText()">+
        <!-- <i class="fa fa-plus" aria-hidden="true"></i> -->
      </button>
    </div>
  </div>
  <div class="my-2">
    <div class="list-box">
      <p class="subtitle">Traducciones custom:</p>
      <ul *ngIf="translationsTextList.length else noTranslationsList" class="list-content">
        <li *ngFor="let translationItem of translationsTextList" class="mb-1 d-flex align-items-center">
          <span>
            <button class="me-2 btn-table-icon" title="Eliminar" (click)="deleteTranslationText(translationItem)">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
          </span>
          <span class="me-2 fw-bolder">{{ translationItem.section_id }}:</span>
          <span class="me-2">{{ translationItem.translation }}</span>
        </li>
      </ul>
      <ng-template #noTranslationsList>
        <p class="text-note my-2 text-center">Aún no hay traducciones.</p>
      </ng-template>
    </div>
  </div>
</div>